import {convertToHexadecimal} from "bukku/shared/ConvertToHexadecimal";

const theme = {};

theme.palette = {
    primary: [
        '#4482FF', // 0: Default [IN USE]
        '#3A78F5', // 1: Darken 4%
        '#3775F2', // 2: Darken 5%  [IN USE]
        'rgba(68, 130, 255, 0.2)', // 3: Fade 20%
        '#4C8AFF', // 4: Lighten 3%
        'rgba(68, 130, 255, 0.75)', // 5: Fade 75%
        '#6AA8FF', // 6: Lighten 15%
        '#63A1FF', // 7: Lighten 12%
        '#3F7DFA', // 8: Darken 2%
        '#3369e7', // 9: Algolia color
        '#5896FF', // 10: Lighten 8%
        '#2b69e6', // 11:
        '#236cfe', // 12: darken 10%
        '#4d88ff', // 13: Lighten 5%
    ],
    secondary: [
        '#2d3446', // 0: DarkBlue  [IN USE]
        '#f1f3f6', // 1: LightBluish  [IN USE]
        '#788195', // 2: LightBlue  [IN USE]
        '#E4E6E9', // 3: LightBluish Darken 5%  [IN USE]
        '#364d79', // 4:
        '#202739', // 5: DarkBlue Darken 5% [IN USE]
        '#f5f6f8', // 6: LighterBluish [IN USE]
        '#e9ebf1', // 7: DarkBluish
        '#F6F8FB', // 8: LighterBluish Lighten 2%
        '#E9EBEE', // 9: LighterBluish Darken 3%
        '#1a1a1a', // 10: Sidebar submenu select
    ],
    color: [
        '#FEAC01', // 0: Orange
        '#42299a', // 1: Purple
        '#F75D81', // 2: Pink
        '#7ED321', // 3: LimeGreen
        '#39435f', // 4: BlueShade
        '#FFCA28', // 5: Yellow [IN USE]
        '#F2BD1B', // 6: Yellow Darken 5% [IN USE]
        '#3b5998', // 7: Facebook  [IN USE]
        '#344e86', // 8: Facebook Darken 5%  [IN USE]
        '#dd4b39', // 9: Google Plus  [IN USE]
        '#d73925', // 10: Google Plus Darken 5%  [IN USE]
        '#e14615', // 11: Auth0  [IN USE]
        '#ca3f13', // 12: Auth0  [IN USE]
        '#e0364c', // 13: themeColor--AlizarinCrimson  [IN USE]
    ],
    warning: [
        '#ffbf00', // 0: Warning
    ],
    success: [
        '#00b16a', // 0: Success
    ],
    error: [
        '#f64744', // 0: Error [IN USE]
        '#EC3D3A', // 1: Darken 4%
        '#FF5B58', // 2: Lighten 8%
    ],
    grayscale: [
        '#bababa', // 0: GreyShade [IN USE]
        '#c1c1c1', // 1: GreyDark
        '#D8D8D8', // 2: Grey
        '#f1f1f1', // 3: GreyAlt
        '#F3F3F3', // 4: GreyLight
        '#fafafa', // 5: DarkWhite
        '#F9F9F9', // 6: DarkerWhite
        '#fcfcfc', // 7: #fff Darken 1%
        '#eeeeee', // 8:
        '#fbfbfb', // 9:
        '#f5f5f5', // 10:
        '#f7f8f9', // 11: today-highlight-bg
    ],
    text: [
        '#323332', // 0: Heading  [IN USE]
        '#595959', // 1: HeadingLight  [IN USE]
        '#979797', // 2: Text  [IN USE]
        '#797979', // 3: TextDark  [IN USE]
        '#6a6c6a', // 4: Heading Lighten 22%
    ],
    border: [
        '#e9e9e9', // 0: Border
        '#d8d8d8', // 1: BorderDark
        '#ebebeb', // 2: BorderLight  [IN USE]
        '#d3d3d3', // 3:
        'rgba(228, 228, 228, 0.65)', // 4:
    ],

    calendar: [
        '#905', // 0:
        '#690', // 1:
        '#a67f59', // 2:
        '#07a', // 3:
        '#dd4a68', // 4:
        '#e90', // 5:
    ],
};

theme.fonts = {
    primary: 'Roboto, sans-serif',
    pre: 'Consolas, Liberation Mono, Menlo, Courier, monospace',
};

theme.sidebar = {
    primary: '#2d3446',
    hover: 'rgba(0,0,0,0)',
    selected: 'rgba(0,0,0,0.4)',

    submenu: 'rgba(0,0,0,0.3)',
    submenuHover: 'rgba(0,0,0,0.45)',
    submenuSelected: 'rgba(0,0,0,0.6)',

    text: '#788195',
    textHover: '#788195',
    textSelected: '#fff',

    top: 'rgba(0,0,0,0.3)',
};

theme.sidebar = {
    main: '#2d3446',
    mainHover: 'transparent',
    selected: 'rgba(0,0,0,0.4)',
    selectedHover: 'rgba(0,0,0,0.55)',

    text: '#788195',
    textHover: '#ffffff',
    textSelected: '#ffffff',
    textSelectedHover: '#ffffff',

    submenu: 'rgba(0,0,0,0.3)',
    submenuHover: 'rgba(0,0,0,0.45)',
    submenuSelected: 'rgba(0,0,0,0.6)',
    submenuSelectedHover: 'rgba(0,0,0,0.75)',

    submenuText: '#788195',
    submenuTextHover: '#ffffff',
    submenuTextSelected: '#ffffff',
    submenuTextSelectedHover: '#ffffff',

    arrow: '#ffffff',
    arrowHover: '#ffffff',
    arrowSelected: '#ffffff',
    arrowSelectedHover: '#ffffff',

    iconNotInSubscription: '#ffa39e80',

    top: 'rgba(0,0,0,0.3)',
};

theme.dashboard = {
    stickers: {
        invoice_coming_due: '#0288D1',
        invoice_overdue: '#0277BD',
        bill_coming_due: '#1565C0',
        bill_overdue: '#0D47A1',
    },
    singleBars: {
        outstanding_invoices: [
            "#6eafd4",
            "#4693c4",
            "#2772b3",
            "#10539a",
            "#0b3269",
        ],
        outstanding_bills: [
            "#6eafd4",
            "#4693c4",
            "#2772b3",
            "#10539a",
            "#0b3269",
        ],
    },
    trends: {
        sales: {
            current_period: '#a0d911',
            past_period: '#d3f261',
        },
        profitLoss: {
            income: "#bae637",
            other_income: "#389e0d",
            expenses: "#ff7a45",
            cost_of_sales: "#d4380d",
            net_profit: "#2f54eb",
        },
        cashflow: {
            inflow: '#bae637',
            outflow: '#ff7a45',
            inflow_pending: '#eaff8f',
            outflow_pending: '#ffccc7',
            ending_balance: '#2f54eb',
            pendingTransparency: convertToHexadecimal(1), // value between 0.0 to 1.0
        },
    },
    breakdowns: {
        colors: [
            // original colors
            // "#41B5E9",
            // "#FA8832",
            // "#E46151",
            // "#34393C",

            // suggested below
            '#096dd9',
            '#389e0d',
            '#cf1322',
            '#531dab',
            '#d46b08',
            '#c41d7f',
            '#2f54eb',
            '#d4380d',
            '#08979c',
            '#7cb305',
        ],
        negativeColors: [ // Currently same as colors,
            // original colors
            // '#f7a35c',
            // '#90ed7d',
            // '#7cb5ec',
            // '#434348',
            // '#8085e9',
            // '#f15c80',

            // suggested below
            '#41b4ea',
            '#389e0d',
            '#ee3137',
            '#722ed1',
            '#f88630',
            '#eb2f96',
            '#2f54eb',
            '#faad14',
            '#13c2c2',
            '#a0d911',
        ],
        negativeColorTransparency: convertToHexadecimal(0.9), // value between 0.0 to 1.0
    },
};

export default theme;
